'use strict';

const $ = require('jquery');
const Cookies = require('../components/cookie');

let updateShippingMethodListCallback;
let globalEventsInitialized = false;

/**
 * Callback function to use billingShipping.updateShippingMethodList()
 *
 * Callback was introduced to not create a cyclic dependency. Might be worth to refactor
 *
 * @param {@callback} callback billingShipping.updateShippingMethodList
 */
function setBillingShippingUpdateCallback(callback) {
    updateShippingMethodListCallback = callback;
}

var $body = $('body'),
    filledOutClass = 'filled-out',
    filledOutRowClass = 'm-filled',
    preventClass = 'prevent-label-move',
    updateTextAreas = function ($textArea) {
        // update the character counter inside the label if there is a maxlength specified:
        ($textArea || $body.find('textarea')).each(function (i, el) {
            if (!isNaN(el.dataset.maxlength)) {
                $(el)
                    .closest('.form-row')
                    .find('.label')
                    .text(function (i, text) {
                        return text.replace(/-?\d+/, +el.dataset.maxlength - el.value.length);
                    });
            }
        });
    },
    updateSelectBoxes = function ($selectbox) {
        if ($selectbox === undefined || $selectbox.length === 0) {
            $('select').each(function () {
                updateSelectBoxes($(this));
            });
        } else {
            var $formrow = $selectbox.closest('.form-row-select'),
                index = $selectbox[0].selectedIndex;

            if (!$selectbox.hasClass(preventClass)) {
                if (index > 0) {
                    $formrow.addClass(filledOutClass + ' ' + filledOutRowClass);
                } else {
                    $formrow.removeClass(filledOutClass + ' ' + filledOutRowClass);
                }
            }
        }
    },
    upcaseZipInit = function () {
        var country = Cookies.get('Country');

        if (country === 'IE' || country === 'GB') {
            $body.on('keyup', '.postal-code', function () {
                var $this = $(this);
                $this.val($this.val().toUpperCase());
            });
        }
    },
    buttonRadio = function ($radio) {
        var $buttons = $radio ? $radio.parent().find('input[type="radio"]') : $('.button-radio input[type="radio"]');

        $buttons.each(function () {
            var $button = $(this);
            $button.parent()[$button.is(':checked') ? 'addClass' : 'removeClass']('active');
        });
    },
    /**
     * Validate and set the highest number of characters allowed in a specific field based on the maxlength attribute value.
     * displays a counter indicating remaining characters, and presents a message to the user if the character limit has been reached
     */
    updateInputLength = function () {
        let $elements = $('input.chars-counter-field');

        // Check if the page has the counter class ".chars-counter-field"
        if ($elements.length === 0) {
            return;
        }

        // Loop through each input element with the class ".chars-counter-field"
        $elements.each(function () {
            let $this = $(this);

            // Check if character counter is already present, if so, just return
            if ($this.next('.max-chars-hint').length > 0) {
                return;
            }

            // Get the maximum allowed length for this field
            let maxLength = $this.attr('maxlength');

            // Get the current input length
            let currentLength = $this.val().length;

            // Create a hint div after the input field, displaying the current/maximum characters
            let $hint = $(
                `<div class="max-chars-hint" style="display: none;"><span></span><span> ${currentLength}/${maxLength}</span></div>`
            ).insertAfter($this);

            // Get the message and counter elements
            let $message = $hint.find('span:first-child');
            let $counter = $hint.find('span:last-child');

            // Attach an input event handler to this element to update the counter and message
            $this.on('input', function () {
                // Update the current length
                currentLength = $this.val().length;

                // Update the counter text
                $counter.text(`${currentLength}/${maxLength}`);

                // If the user has reached or exceeded the max length, show a message
                $message.text(currentLength >= maxLength ? Resources.MAX_CHARS_REACHED : '');
            });
        });

        // Add a focus event handler for the input fields to show the hint when they receive focus
        $(document).on('focus', 'input.chars-counter-field', function () {
            let $this = $(this);
            // Show the hint div when the input receives focus
            $this.next('.max-chars-hint').show();
        });

        // Add a blur event handler for the input fields to hide the hint when they lose focus
        $(document).on('blur', 'input.chars-counter-field', function () {
            let $this = $(this);
            // Hide the hint div when the input loses focus
            $this.next('.max-chars-hint').hide();
        });
    },
    locationsDropdownSelection = function () {
        const dimensionsElement = '#dimensions';
        let jsonData;
        // validationErrorClass & dropDownErrorMsg - Related Error classes and msg
        const rowErrorClass = 'validation-error';
        const validationErrorClass = 'validation-error-dropdown';
        const dropDownErrorMsg = Resources.VALIDATE_LOCLIST;

        // Main Function execution
        try {
            // Parse the JSON data from the "#dimensions" element
            jsonData = $(dimensionsElement).data('json');
            const $addressSelectionGroups = $('.address-selection-group');
            initializeAddressSelectionGroups($addressSelectionGroups);
        } catch (error) {
            // JSON error handling
            console.log('Error parsing the JSON: ', error);
        }

        /**
         * Initializes address selection groups.
         * @param {jQuery} $groups - the address selection groups.
         */
        function initializeAddressSelectionGroups($groups) {
            $groups.each(function () {
                const $group = $(this);
                const $inputs = $group.find('input[type="text"]');

                // Disable all input fields except the first one - not if they have value. field edit test case.
                $inputs
                    .not(':first')
                    .filter((_, input) => !$(input).val())
                    .prop('disabled', true);

                $inputs.each((index, input) => {
                    const $input = $(input);
                    // input focus event
                    $input.on('focus', () => {
                        handleInputFocus($input, $group, index);
                    });
                    // input focus out event
                    $input.on('blur', () => {
                        handleInputBlur($group);
                    });
                    $input.on('change', e => {
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    // Handles the input event
                    $input.on(
                        'input',
                        debounce(() => {
                            handleInputChange($group, $inputs, $input, index);
                        }, 300)
                    );
                });
            });
        }

        /**
         * Handles the input focus event.
         * @param {jQuery} $group - the address selection group.
         * @param {jQuery} $input - the input field.
         * @param {number} currentIndex - The index of the current input field.
         */
        function handleInputFocus($input, $group, currentIndex) {
            const hintContent = Resources[`VALIDATE_LOCLIST_HINT_${currentIndex}`];
            showHintMessage($input, $group, hintContent);
        }
        /**
         * Handles the input blur event.
         * @param {jQuery} $input - the input field.
         * @param {jQuery} $group - the address selection group.
         */
        function handleInputBlur($group) {
            removeHintMessage($group);
        }
        /**
         * Handles the input change event.
         * @param {jQuery} $group - the address selection group.
         * @param {jQuery} $inputs - the list of input fields inside the group.
         * @param {jQuery} $input - the input field.
         * @param {number} index - The index of the current input field.
         */
        function handleInputChange($group, $inputs, $input, index) {
            const value = $input.val().toLowerCase().trim();
            const formRowElement = '.form-row';
            // Escape special characters
            function escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }

            // Remove existing error messages and the error validation class
            $input.parent().removeClass(validationErrorClass);
            $input.siblings('.locations-list-error').remove();

            // Show or hide start typing hint based on input value
            if (!value) {
                const hintContent = Resources[`VALIDATE_LOCLIST_HINT_${index}`];
                showHintMessage($input, $group, hintContent);
            } else {
                removeHintMessage($group);
            }
            // Clear and disable all the "Next inputs" if the current input value changes
            $inputs
                .slice(index + 1)
                .val('')
                .prop('disabled', true)
                .siblings('.locations-list-container')
                .remove();

            // Return early if the input value is empty
            if (!value) {
                $input.siblings('.locations-list-container').remove();
                return;
            }
            // Get the values of all the previous input fields in the current group
            const previousValues = $inputs
                .slice(0, index)
                .map(function () {
                    return $(this).val();
                })
                .get();
            // Update the currentData based on the selected values in the previous input fields
            let availableEntries = getAvailableEntries(jsonData, previousValues);

            const escapedValue = escapeRegExp(value);
            // Filter the current data based on the input value
            const filteredData = availableEntries.filter(dimension => {
                const regex = new RegExp(escapedValue, 'i');
                return regex.test(dimension);
            });
            // Show the dropdown list if there are matching items
            if (filteredData.length) {
                $input.closest(formRowElement).addClass(`${rowErrorClass} ${validationErrorClass}`);
                // Remove previous list before creating a new one
                $input.siblings('.locations-list-container').remove();
                // Create the dropdown list of location values - div > ul to hold the locations list <li>
                const $listContainer = $('<div>').addClass('locations-list-container');

                $listContainer.on('click', e => {
                    // Set the value of the current input to the selected value
                    $input.val(e.target.textContent);
                    $listContainer.remove();
                    // Enable the next input field when a value is selected
                    if (index + 1 < $inputs.length) {
                        $inputs.eq(index + 1).prop('disabled', false);
                    }
                    $input.closest(formRowElement).removeClass(`${rowErrorClass} ${validationErrorClass}`);

                    //trigger the ajax call to verify the shipping method
                    //'onchange' is bound already and fires for each change which is not neccessary
                    //here we can assume that only after a user clicks a call needs to be made
                    if (updateShippingMethodListCallback) {
                        updateShippingMethodListCallback();
                    }
                });

                const $list = $('<ul>');
                // Iterate over each dimension (location) in the filtered data and create a list item for each one
                filteredData.forEach(dimension => {
                    const $item = $('<li>').text(dimension);
                    $list.append($item);
                });
                $listContainer.append($list);
                $input.after($listContainer);
            } else {
                // Show error message if input value does not match any items in the list
                const $error = $('<div>').addClass('locations-list-error').append($('<span>').text(dropDownErrorMsg));
                $input.closest(formRowElement).addClass(validationErrorClass).append($error);
                $input.siblings('.locations-list-container').remove();
            }
        }
        /**
         * Returns the currently available options to filter by, based on the selected values in the previous input fields
         *
         * Full dimensions example
         * [{"Hong kong":[{"New Territories":["Yuen Long","Wo Sang Wai"]},{"Kowloon":["Tung Chung","Tuen Mun"]}]},{"Macau":[{"Macau":["Taipa","Peninsula","Coloane"]}]}]
         *
         * Noteworthy is that the last 'level' is a pure string or number array. Opposit to the previous 'object' arrays containing the translated values as 'keys'
         *
         * @param {Array} dimensions - The dimensions array from the JSON data.
         * @param {Array<string>} previousValues - The values of the previous input fields.
         * @returns {Array<string>} - Currently available options to filter by
         */
        function getAvailableEntries(dimensions, previousValues) {
            if (previousValues.length === 0) {
                return dimensions.map(entry => {
                    if (typeof entry === 'string' || typeof entry === 'number') {
                        return entry;
                    } else {
                        return Object.keys(entry)[0];
                    }
                });
            } else {
                return iterateToNestedEntries(dimensions, previousValues.reverse());
            }
        }

        /**
         *
         * @param {Array} dimensions - The dimensions array from the JSON data.
         * @param {Array<string>} previousValues - The values of the previous input fields.
        * @returns {Array<string>} - Currently available options to filter by

         */
        function iterateToNestedEntries(dimensions, previousValues) {
            const previousvalue = previousValues.pop();

            const currentLevel = dimensions.find(entry => {
                const key = Object.keys(entry)[0];
                if (key === previousvalue) {
                    return entry;
                }
            });

            if (previousValues.length === 0) {
                return currentLevel[previousvalue].map(entry => {
                    if (typeof entry === 'string' || typeof entry === 'number') {
                        return entry;
                    } else {
                        return Object.keys(entry)[0];
                    }
                });
            } else {
                return iterateToNestedEntries(currentLevel[previousvalue], previousValues);
            }
        }

        /**
         * Shows a hint message for the input field.
         * @param {jQuery} $input - the input field.
         * @param {jQuery} $group - the address selection group.
         * @param {string} hintContent - The hint message to be displayed.
         */
        function showHintMessage($input, $group, hintContent) {
            // Remove previous hint before creating a new one
            $group.find('.start-typing-hint').remove();
            // Show start typing hint when input is in focus and field is empty
            if (!$input.val()) {
                const $hint = $('<div>').addClass('start-typing-hint').append($('<span>').text(hintContent));
                $input.after($hint);
            }
        }
        /**
         * Removes the hint message from the input field.
         * @param {jQuery} $group - the address selection group.
         */
        function removeHintMessage($group) {
            $group.find('.start-typing-hint').remove();
        }

        /**
         * Debounces function to limit the rate for the input listener - handleInputChange
         * @param {function} handleInputChangeDebounced - The function of handleInputChange we debounced.
         * @param {number} wait - The number of milliseconds to wait before calling the function (handleInputChange).
         * @returns {function} - A debounced version of the input function.
         */
        function debounce(handleInputChangeDebounced, wait) {
            let timeout;
            // Return the function that will be called with the debounced behavior (300 ms)
            return function (...args) {
                const inputElement = this; // Save the inputElement (the value of input) to use it later
                // Clear any existing timeout to prevent the previous function call from executing
                clearTimeout(timeout);
                // Set new timeout to execute the function after the 300 ms interval
                timeout = setTimeout(() => handleInputChangeDebounced.apply(inputElement, args), wait);
            };
        }
    },
    /**
     * @function dobSelectorDropdownValidate
     * @description Validates user selections for 'Date of Birth' selectors in forms, detecting any missing fields.
     */
    dobSelectorDropdownValidate = function () {
        const selectorString = '.form-dob .input-select';
        const validationErrorClass = 'validation-error';
        const errorMsgClass = 'error-msg';

        // Using on document change for the case when form AJAX saved "My profile > My Data form" fix
        $(document).on('change', selectorString, function () {
            let $form = $(this).closest('form');
            let $selectors = $form.find(selectorString);
            let $dobSection = $(this).closest('.form-dob');

            // Check if all selectors are empty
            let allEmpty =
                $selectors.filter(function () {
                    return $(this).val().trim() === '';
                }).length === $selectors.length;

            $selectors.each(function () {
                let $parentRow = $(this).closest('.form-row-select');

                if (allEmpty) {
                    // If all selectors are empty, remove the validation error class (as DOB fields are optional)
                    $parentRow.removeClass(validationErrorClass);

                    // Remove error messages only from sibling selectors within the same .form-dob section
                    $dobSection.find(`.${errorMsgClass}`).remove();
                } else {
                    // If at least one selector has a value, toggle the validation error class and remove error message based on each selector's value
                    const hasValue = $(this).val().trim() !== '';
                    $parentRow.toggleClass(validationErrorClass, !hasValue);
                    if (hasValue) {
                        $parentRow.find(`.${errorMsgClass}`).remove();
                    }
                }
            });
        });
    },
    /**
     * It validates all password fields (except confirmation field) in the form for complexity based on various criteria.
     * @function
     * @listens input event on '.input-password' elements
     */

    passwordMatchValidate = function () {
        $('.password-show-container .input-password')
            .not('.no-criteria-eligible')
            .on('input', function () {
                const form = $(this).closest('form');
                const passwordsFields = form.find('.input-password');
                if (passwordsFields.length < 2) {
                    return; // Only one field (Login form case), exit early
                }

                // Validate all password fields in the same form and update UI
                passwordsFields
                    .not('.no-criteria-eligible')
                    .not(':last')
                    .each(function () {
                        const isValid = validatePasswordField($(this));
                        updateUIAfterValidation($(this), isValid, passwordsFields);
                    });
            });
    },
    /**
     * Validates a given password field against multiple criteria such as minimum length, special characters, mixed case, letters, and numbers. The criteria from BM (Administration >  Sites >  Customer Lists)
     *
     * @function
     * @param {jQuery} passwordField - The password input field to validate.
     * @returns {boolean} - Returns `true` if the password meets all criteria, otherwise `false`.
     */
    validatePasswordField = function (passwordField) {
        let PASSWORD_MIN_LENGTH = Resources.PASSWORD_MIN_LENGTH; // Number
        let PASSWORD_MIN_SPECIAL_CHARS = Resources.PASSWORD_MIN_SPECIAL_CHARS; // Number
        let PASSWORD_IS_FORCE_LETTERS = Resources.PASSWORD_IS_FORCE_LETTERS; // Boolean
        let PASSWORD_IS_FORCE_MIXED_CASE = Resources.PASSWORD_IS_FORCE_MIXED_CASE; // Boolean
        let PASSWORD_IS_FORCE_NUMBERS = Resources.PASSWORD_IS_FORCE_NUMBERS; // Boolean

        const minPasswordLength = PASSWORD_MIN_LENGTH || 8;

        const hasMinSpecialChars = password => {
            const specialCharsRegex = /[^A-Za-z0-9]/g;
            return (password.match(specialCharsRegex) || []).length >= PASSWORD_MIN_SPECIAL_CHARS;
        };

        const hasLetters = password => /[A-Za-z]/.test(password);
        const hasMixedCase = password => /[a-z]/.test(password) && /[A-Z]/.test(password);
        const hasNumbers = password => /\d/.test(password);

        const passwordValue = passwordField.val();
        const passwordLengthValid = passwordValue.length >= minPasswordLength;
        const passwordSpecialCharsValid = hasMinSpecialChars(passwordValue);
        const passwordLettersValid = PASSWORD_IS_FORCE_LETTERS ? hasLetters(passwordValue) : true;
        const passwordMixedCaseValid = PASSWORD_IS_FORCE_MIXED_CASE ? hasMixedCase(passwordValue) : true;
        const passwordNumbersValid = PASSWORD_IS_FORCE_NUMBERS ? hasNumbers(passwordValue) : true;
        // Consolidate the validation checks
        const passwordValid =
            passwordLengthValid &&
            passwordSpecialCharsValid &&
            passwordLettersValid &&
            passwordMixedCaseValid &&
            passwordNumbersValid;

        // Return the validation result
        return passwordValid;
    },
    // Update Password field UI after validation
    updateUIAfterValidation = function (passwordField, isValid, passwordsFields) {
        updateTickIcon(passwordField, isValid);
        const parentRow = passwordField.closest('.form-row');
        const passwordCriteriaValidateClass = 'validation-error password-criteria-error';
        parentRow.toggleClass(passwordCriteriaValidateClass, !isValid);

        // Validate confirmation password field
        if (passwordsFields.length > 1) {
            const confirmationField = passwordsFields.last();
            updateConfirmationPasswordField(confirmationField, passwordsFields);
        }
    },
    // Update the tick icon based on validity
    updateTickIcon = function (field, isValid) {
        const tickIcon = field.siblings('.password-show-btn').find('.tick-icon');
        tickIcon.toggle(isValid);
    },
    // Update the confirmation password field
    updateConfirmationPasswordField = function (confirmationField, passwordsFields) {
        const previousPasswordField = passwordsFields.eq(passwordsFields.length - 2);
        const previousPasswordValid = previousPasswordField.val().length >= Resources.PASSWORD_MIN_LENGTH;
        const isMatch = previousPasswordValid && confirmationField.val() === previousPasswordField.val();
        const parentRow = confirmationField.closest('.form-row');
        const passwordMatchValidateClass = 'validation-error password-match-error';

        updateTickIcon(confirmationField, isMatch);
        parentRow.toggleClass(passwordMatchValidateClass, !(isMatch && previousPasswordValid));

        if (isMatch && previousPasswordValid) {
            parentRow.find('.error-msg').remove();
        } else {
            parentRow.addClass(passwordMatchValidateClass);
        }
    },
    inputfields = {
        updateSelectBoxes: updateSelectBoxes,
        setBillingShippingUpdateCallback: setBillingShippingUpdateCallback,

        /**
         * @function
         * @description initializes the label move feature for input fields and select boxes
         */
        init: function () {
            updateTextAreas();
            updateSelectBoxes();
            upcaseZipInit();
            buttonRadio();
            dobSelectorDropdownValidate();
            passwordMatchValidate();

            if (SitePreferences.CHARS_COUNTER_ADDRESS) {
                updateInputLength();
            }

            if (SitePreferences.DIMENSIONAL_DROPDOWN_ENABLED) {
                locationsDropdownSelection();
            }
            let selectElement;
            const browserWidth = $(window).width();
            const browserWidthBreakPoint = 768;
            const isDesktop = browserWidth >= browserWidthBreakPoint;

            if (!globalEventsInitialized) {
                $body
                    .on('blur', 'input, textarea', function () {
                        var $inputfield = $(this),
                            value = $inputfield.val();

                        if (!$inputfield.hasClass(preventClass)) {
                            if (value && value.length > 0) {
                                $inputfield.addClass(filledOutClass);
                                $inputfield.closest('.form-row').addClass(filledOutRowClass);
                            } else {
                                $inputfield.removeClass(filledOutClass);
                                $inputfield.closest('.form-row').removeClass(filledOutRowClass);
                            }
                        }
                    })
                    .on('change', 'select', function () {
                        updateSelectBoxes($(this));

                        if (!isDesktop) {
                            $(this).blur();
                        }
                    })
                    .on('click', 'select', function () {
                        // Keep the first select.
                        if (!selectElement) {
                            selectElement = $(this);
                        }

                        // The user has clicked on another select.
                        if (!selectElement.is($(this)) && isDesktop) {
                            $.uniform.update(selectElement);
                            selectElement = $(this);
                        }
                    })
                    .on('keyup', 'textarea', function () {
                        updateTextAreas($(this));
                    })
                    .on('change', '.button-radio input:radio', function () {
                        buttonRadio($(this).parent());
                    });
                globalEventsInitialized = true;
            }
            // Necessary to avoid a glitch on mobile devices - BSDDEV-929
            $('.button-radio').on('click', function () {
                $(this).siblings().removeClass('active');
                $(this).addClass('active');
                $(this).parents('.salutation-button').removeClass('unselected');
            });
            $('.salutation-button .button-radio').each(function () {
                if ($(this).hasClass('active')) $(this).parents('.salutation-button').removeClass('unselected');
            });
        }
    };

module.exports = inputfields;
